import {createFileRoute} from "@tanstack/react-router";
import {
    ADGPT_TOKEN_LEDGER_QUERY_KEY,
    getPlatformUserDetails,
    getTokenLedger,
} from "../adgpt-tokens/-data";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/adgpt-token-ledger",
)({
    loader: async ({context}) => {
        const accessToken = context.authenticationStatus.accessToken;
        const [ledger, userDetails] = await Promise.all([
            context.queryClient.ensureQueryData({
                queryKey: [ADGPT_TOKEN_LEDGER_QUERY_KEY, "all"],
                queryFn: async () =>
                    await getTokenLedger({
                        accessToken: accessToken,
                        plutoBaseUrl: `${context.intellsysBaseUrl}/sub-system/pluto`,
                    }),
            }),
            getPlatformUserDetails({
                accessToken: accessToken,
                plutoBaseUrl: `${context.intellsysBaseUrl}/sub-system/pluto`,
                queryClient: context.queryClient,
            }),
        ]);

        return {
            accessToken: accessToken,
            ledger: ledger,
            userDetails: userDetails,
            intellsysBaseUrl: context.intellsysBaseUrl,
        };
    },
    component: RouteComponent,
});
